import { AnalyticsBrowser } from "@segment/analytics-next";
import type { CommonPlugin, EventConsumerPlugin } from "zudoku/plugins";

const WRITE_KEY = import.meta.env.ZUDOKU_PUBLIC_SEGMENT_WRITE_KEY as string | undefined;

let analytics: AnalyticsBrowser | null = null;

export const segmentPlugin: (CommonPlugin & EventConsumerPlugin) | null = WRITE_KEY
  ? {
      initialize: () => {
        if (typeof window === "undefined") return;
        analytics = AnalyticsBrowser.load({ writeKey: WRITE_KEY });
      },

      events: {
        location: ({ to }) => {
          analytics?.page(to.pathname);
        },

        auth: ({ next }) => {
          if (!next.isAuthenticated || !next.profile) return;
          analytics?.identify(next.profile.sub, {
            email: next.profile.email,
            name: next.profile.name,
          });
          const orgId = next.profile["org_id"];
          if (orgId && typeof orgId === "string") {
            analytics?.group(orgId);
          }
        },
      },
    }
  : null;
